export function getContestantsState () {
    return {
        cards: []
    }
}

export function getRegisterState () {
    return {
        form: {
            name: '',
            image: '',
            category: '',
            categoryItems: [
                'Baseball',
                'Basketball',
                'Cricket',
                'Football:NCAA',
                'Football:NFL',
                'Friends',
                'Office',
                'TV Shows',
                'Tennis',
                'Fight Night',
                'Boxing',
                'Other'
            ],
            filterItems: [
                'All',
                'Favorite'
            ],
            prompt: '',
            partOfTournament: false,
            tournament: '',
            newTournament: '',
            tournamentImage: '',
            tournamentItems: [{text: 'New Tournament', value: 'new'}],
        }
    }
}

export function getShareState () {
    return {
        form: {
            privacy: '',
            group: {},
            groups: [{text: 'New Group', value: 'New Group'}],
        }
    }
}

export function getTimingState () {
    return {
        form: {
            deadline: true,
            startOption: 'dateTime',
            winnerOption: 'dateTime',
            startDate: '',
            startTime: '',
            winnerDate: '',
            winnerTime: '',
        }
    }
}

export function getWinnerState () {
    return {
        form: {
            type: '',
        },
        simple: {
            prize: 'scoins',
            winSCoins: 100,
            winnerSelection: '',
            numWinners: 3,
            noLimit: false,
            hashtag: '',
            description: '',
            image: ''
        },
        pool: {
            minCoinsToPlay: '',
            maxCoinsToPlay: '',
            SCoinGM: 0
        },
        total: {
            totalpoints: '',
            wagerSCoins: 11,
            winSCoins: 10,
            SCoinGM: ''
        },
        line: {
            SCoinFavored: '',
            SCoinUnderdog: '',
            winSCoins: 10,
            SCoinGM: '',
        },
        spread: {
            pointSpread: '',
            wagerSCoins: 11,
            winSCoins: 10,
            SCoinGM: ''
        },
        bracket: {
            bracketModel: "",
            winnerLabel: ""
        }
    }
}

export function getInstaplayFormState () {
    return {
        status: '',
        errorMessage: '',
        itemStatus: '',
        step: 1,
        limits: {
            played: false,
            playedMessage: '',
            type: false,
            typeMessage: ''
        },
        validation: {
            register: 'notValidated',
            contestants: 'notValidated',
            timing: 'notValidated',
            winner: 'notValidated',
            share: 'notValidated',
        }
    }
}

export function getAdminState () {
    return {
        status: {
            update: '',
            load: '',
        },
        userIds: [],
        countUser: 0,
        users: [],
    }
}

export function getAuthState () {
    function getUser() {
        try {
            let user = JSON.parse(localStorage.getItem('user'))
            if (user) return user
            else return {}
        } catch (e) {
            localStorage.removeItem('user')
            return {}
        }
    }

    return {
        status: '', // loading, success, error
        registerStatus: '',
        infoStatus: '',
        registerError: '',
        user: getUser(),
        userError: '',
        passwordError: '',
    }
}

export function getInstaplaysState () {
    return {
        status: {
            current: '',
            active: '',
            completed: '',
            manage: '',
            manageActive: '',
            manageWaiting: '',
            manageDeclared: '',
            declare: '',
            edit: '',
        },
        mode: 'current',
        playStatus: {
            status: '',
            message: '',
            alert: false
        },
        instaplayIDs: {
            current: [],
            active: [],
            completed: [],
            manage: [],
            manageActive: [],
            manageWaiting: [],
            manageDeclared: [],
        },
        activePlayIds: {},
        completedPlays: {},
        userPlays: {},
        instaplayOutcome: {},
        poolBalance: {},
        instaplays: {
            current: [],
            active: [],
            completed: [],
            manage: [],
            manageActive: [],
            manageWaiting: [],
            manageDeclared: [],
        },
        count: {
            current: 0,
            active: 0,
            completed: 0,
            manage: 0,
            manageActive: 0,
            manageWaiting: 0,
            manageDeclared: 0,
        },
        toFetch: {
            current: 0,
            active: 0,
            completed: 0,
            manage: 0,
            manageActive: 0,
            manageWaiting: 0,
            manageDeclared: 0,
        },
        perCall: 5,
    }
}

export function getNotificationState () {
    return {
        snackbar: {
            show: false,
            text: '',
            timeout: 6000,
            type: 'info'
        },
    }
}
